<template>
  <div class="w-full">
    <div
      class="group hover:bg-primary/10 flex w-full cursor-pointer items-center rounded"
      :class="{
        'bg-primary-600/20': selectionStore.selectedObjectId === item.code,
      }">
      <div class="flex min-w-0 flex-auto">
        <div class="min-w-0 flex-auto overflow-hidden">
          <div class="flex items-center space-x-2">
            <div class="pi pi-camera px-1.5 text-gray-400"></div>
            <div class="truncate py-1.5 text-nowrap text-gray-400">
              {{ item.name ?? 'Object' }}
            </div>
          </div>
        </div>
      </div>

      <div class="hidden flex-none">
        <DButton
          text
          size="small"
          class="group-hover:text-primary w-auto p-1.5"
          :class="item.properties?.locked ? 'text-gray-200' : 'text-gray-500'"
          @click="
            (event) => {
              event.stopPropagation();
              if (!item.properties) {
                item.properties = {};
              }
              item.properties.locked = !item.properties.locked;
            }
          ">
          <LockClosed v-if="item.properties?.locked" class="h-5 w-5" />
          <LockOpen v-else class="h-5 w-5"
        /></DButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSelectionStore } from '@/stores/ui/selection';
import { DButton } from '@disguise/cloud-ui';
import { LockClosed, LockOpen } from '@disguise/cloud-ui/icons';
import { onUnmounted } from 'vue';

const selectionStore = useSelectionStore();
const props = defineProps({
  item: Object,
});

onUnmounted(() => {
  if (selectionStore.selectedObjectId === props.item?.code) selectionStore.clearSelection();
});
</script>
